import React from "react";
import { Box, Typography } from "@material-ui/core";
import { FormProvider, useForm } from "react-hook-form";
import CDialog from "shared/CDialog";
import { Loading } from "shared";
import { useGetLesson } from "routes/createContent/api/useGetLesson";
import PreviewColumn from "routes/createContent/views/lessons/components/preview/PreviewColumn";
import { ActiveLocaleProvider } from "routes/createContent/views/lessons/ActiveLocaleContext";
import { LessonFormData } from "routes/createContent/views/lessons/types";

type Props = {
  lessonId: number | null;
  onClose: () => void;
};

// PreviewColumn reads the lesson from react-hook-form context, so we hydrate a
// throwaway form with the fetched lesson data and render it inside the same
// ActiveLocaleProvider the editor uses.
const PreviewForm: React.VFC<{ data: LessonFormData }> = ({ data }) => {
  const form = useForm<LessonFormData>({ defaultValues: data, shouldUnregister: false });
  return (
    <FormProvider {...form}>
      <PreviewColumn />
    </FormProvider>
  );
};

// Reuses the lesson editor's live preview (PreviewColumn) in a dialog.
const LessonPreviewDialog: React.VFC<Props> = ({ lessonId, onClose }) => {
  const { data, isLoading, isError } = useGetLesson(lessonId);

  return (
    <CDialog open={lessonId != null} onClose={onClose} maxWidth="sm" fullWidth>
      <Box px={2} pb={2} display="flex" justifyContent="center">
        {isLoading && <Loading />}
        {isError && <Typography color="error">Failed to load lesson.</Typography>}
        {!isLoading && !isError && data && (
          <ActiveLocaleProvider inUrl={false}>
            <PreviewForm key={lessonId ?? "none"} data={data} />
          </ActiveLocaleProvider>
        )}
      </Box>
    </CDialog>
  );
};

export default LessonPreviewDialog;
